<template>
    <section>
        <div class="card events-card">
            <header class="card-header">
                <p class="card-header-title">
                    Events
                </p>
            </header>
            <div class="card-table" style="max-height:60vh;">
                <div class="content">
                    <table class="table is-size-5 is-striped">
                        <thead>
                            <tr>
                                <th>Date-Time</th>
                                <th>Sensor</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="event in events">
                                <td><span>{{simplifyDate(event[2])}}</span></td>
                                <td>{{event[0]}}</td>
                                <td><a class="button is-dark greyBG has-text-weight-normal" href="#">{{event[1]}}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    props: {
        events: Array
    },
    methods: {
        simplifyDate(date) {
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
        }
    }
}
</script>

<style scoped>
.events-card .card-table {
  overflow-y: scroll;
}
</style>
